import { render } from "./indexCleanNetAction-clone.vue?vue&type=template&id=b365e23e&scoped=true&ts=true"
import script from "./indexCleanNetAction-clone.vue?vue&type=script&lang=ts"
export * from "./indexCleanNetAction-clone.vue?vue&type=script&lang=ts"

import "./indexCleanNetAction-clone.vue?vue&type=style&index=0&id=b365e23e&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b365e23e"]])

export default __exports__